<template>
    <section id="footer" class="non-printable">
        <div class="inner footer">
            <!-- Phone -->
            <div class="col-xs-4 animated footer-box" data-animation="flipInY" data-animation-delay="0">
                <!--<a class="footer-links">
                    <i class="fa fa-mobile"></i>
                </a>

                <p class="footer-text">
                    <span>Phone</span>:<span>(123) 000-000000</span>
                </p>-->
            </div>

            <!-- Socials and Mail -->
            <div class="col-xs-4 animated footer-box" data-animation="flipInY" data-animation-delay="0">

                <!-- Social 1 -->
                <a class="footer-links" href="https://www.facebook.com/EFGHermes">
                    <i class="fa fa-facebook"></i>
                </a>

                <!-- Social 2 -->
                <a class="footer-links" href="https://twitter.com/efghermes">
                    <i class="fa fa-twitter"></i>
                </a>

                <!-- Social 3 -->
                <a class="footer-links" href="https://www.youtube.com/user/EFGHermesHolding">
                    <i class="fa fa-youtube"></i>
                </a>

                <!-- Social 4 -->
                <a class="footer-links" href="https://www.linkedin.com/company/efg-hermes/">
                    <i class="fa fa-linkedin"></i>
                </a>

                <!-- Mail -->
                <p class="footer-text">
                    <span>Email</span>:<span><a
                            href="mailto:OneOnOne@EFG-HERMES.com">OneOnOne@EFG-HERMES.com</a></span>
                </p>

                <!-- Copyright -->
                <p class="footer-text copyright">
                    ©2023 EFG Hermes. All Rights Reserved.
                </p>
            </div>

            <!-- Adress -->
            <div class="col-xs-4 animated footer-box" data-animation="flipInY" data-animation-delay="0">

                <!--<a class="footer-links">
                    <i class="fa fa-map-marker"></i>
                </a>

                <p class="footer-text">
                    1234 Street Name, City Name
                </p>-->
            </div>

            <div class="clear"></div>
        </div> 
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "Footer",
    computed: {
        ...mapGetters(['conferenceTextData'])
    }
};
</script>

<style scoped>
@media print {
    .non-printable {
        display: none;
    }
}
</style>
